<style lang="scss" scoped>
.slide-12 {
  background-image: url(../../../assets/module1/slide12/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-top: 100px;
  padding-left: 90px;
  height: calc(100% - 100px);
}
h1 {
  max-width: 1090px;
  font-size: 54px;
  line-height: 64px;
  color: #c5d43b;
  transform: rotate(-5deg);
  text-align: center;
}
p {
  color: white;
  display: inline;
}
.content {
  margin-top: 80px;
  padding-left: 41px;
}
.num {
  font-size: 72px;
  white-space: nowrap;
  span {
    color: #e30613;
  }
}
.top-para {
  position: relative;
  max-width: 812px;
  margin-bottom: 46px;
  .num {
    position: absolute;
    top: 105px;
    transform: translateX(15px);
  }
}
.bottom {
  max-width: 518px;
}
h2 {
  color: #c5d43b;
  font-size: 54px;
  line-height: 64px;
  margin-top: 50px;
}
</style>

<template>
  <div class="slide-12">
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 11"
        src="@/assets/module1/slide12/fridge-01.png"
        class="chars delay-5"
      />
    </transition>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 11"
        src="@/assets/module1/slide12/photos-12.png"
        class="chars delay-4"
      />
    </transition>
    <transition name="fadeLeft" appear>
      <div v-show="slideIndex == 11">
        <h1 v-html="$t('module1.slide12.heading')"></h1>
      </div>
    </transition>
    <div class="content">
      <transition name="fadeLeft" appear>
        <div v-show="slideIndex == 11" class="top-para delay-1">
          <p v-html="$t('module1.slide12.paragraph')"></p>
          <p class="kooky num">
            {{ $t("module1.slide12.number") }} <span>000</span>
          </p>
        </div>
      </transition>
      <div class="bottom">
        <transition name="fadeLeft" appear>
          <div v-show="slideIndex == 11" class="delay-2">
            <p>{{ $t("module1.slide12.paragraph2") }}</p>
          </div>
        </transition>
        <transition name="fadeLeft" appear>
          <h2 class="delay-3" v-show="slideIndex == 11">
            {{ $t("module1.slide12.heading2") }}
          </h2>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
